module.exports = __webpack_public_path__ + "img/иконки-21.ca8ec5a0.svg";